import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FaFilePdf } from "react-icons/fa6";
import { useEffect, useRef, useState } from 'react';
import { FaBarcode } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, convertToNumber } from '../CommonComponents/CustomHooks';
import { AutoCompleteBoxNew, FormButton, InputBox } from '../CommonComponents/InputBox';

const UpdateCandidateData = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [tableData, setTableData] = useState([])
    const [formData, setFormData] = useState({
        candidateID: '',
        clientCode: '',
        eventCode: '',
        rollNo: '',
        alternateMobileNo: '',
        alternateEmailID: ''
    });

    const getCandidateData = async () => {
        const data = {
            Type: 'S',
            ...formData,
            PageIndex: '1',
        }
        await dispatch(setSubLoading(true))
        let res = await ApiCall(`/api/Operation/GetCandidateRecord`, data)
        await dispatch(setSubLoading(false))
        if (res.Status === "SUCCESS") {
            setTableData(res)
            setFormData((pre) => ({
                ...pre,
                candidateID: res?.Data[0]?.Edit,
                alternateMobileNo: '',
                alternateEmailID: ''
            }))
        }
        else if (res.Status === "ERROR" || res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
            setTableData([])
        }
    }

    function downloadFile(url, fileName) {
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName || 'download.pdf';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
    }

    const handleClear = async () => {
        setFormData({
            candidateID: '',
            clientCode: '',
            eventCode: '',
            rollNo: '',
            alternateMobileNo: '',
            alternateEmailID: ''
        });
        setTableData([])
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Operation/UpdateAlterNateMobileEmail`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    useEffect(() => {
        document.title = 'Update Candidate Data'
        inputrefs.current['txtClientCode'].focus();
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Update Candidate Data'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <AutoCompleteBoxNew
                                id="txtClientCode"
                                label='Client Code'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEventCode'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='10'
                                placeholder='Client Code'
                                name='ClientCode'
                                value={formData.clientCode || ''}
                                onChange={(e) => setFormData({ ...formData, clientCode: e.target.value })}
                                autocompleteType='GetClientData'
                            />
                            <AutoCompleteBoxNew
                                id="txtEventCode"
                                label='Event Code'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtRollNo'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='10'
                                placeholder='Event Code'
                                name='EventCode'
                                value={formData.eventCode || ''}
                                autocompleteType='GetEventData'
                                contextKey={formData.clientCode}
                                onChange={async (eventCode, newInputValue) => {
                                    newInputValue = newInputValue || ''
                                    if (eventCode.type !== 'keydown') {
                                        setFormData({ ...formData, eventCode: newInputValue })
                                    }
                                }}
                            />
                            <InputBox
                                id="txtRollNo"
                                required={true}
                                label='Roll No'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                maxLength='50'
                                placeholder='Roll No'
                                name='RollNo'
                                value={formData.rollNo}
                                onChange={(e) => setFormData({ ...formData, rollNo: convertToNumber(e.target.value) })}
                            />

                            <div className='card-body mt-2'>
                                <FormButton
                                    id={'btnSub'}
                                    save={false}
                                    search={true}
                                    handleSearch={getCandidateData}
                                    inputrefs={inputrefs}
                                    Export={false}
                                    handleClear={handleClear}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {tableData?.Data &&
                <>
                    <div className='row'>
                        <div className='col-sm-5'>
                            <StyledCard key={'1'}>
                                <CardHeader
                                    title={
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                                <div className='d-flex align-items-center justify-content-center gap-2'>
                                                    <strong>Roll No : </strong> <span className="text-success fw-bold">{tableData && tableData?.Data[0]?.RollNo}
                                                    </span>
                                                </div>
                                            </Typography>
                                        </Box>
                                    }
                                    sx={{ backgroundColor: 'var(--last_bg_all)', color: 'var(--text)', padding: '10px', borderBottom: `1px solid red` }}
                                />
                                <Divider />
                                <CardContent sx={{ padding: '10px' }}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={12}>
                                            <Box sx={{ marginBottom: 1 }}>
                                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                                    <strong>Client Name : </strong>&nbsp;&nbsp; <span className='text-danger fw-bold'>{tableData && tableData?.Data[0]?.ClientName}</span>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ marginBottom: 1 }}>
                                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                                    <strong>Event Name:</strong>&nbsp;&nbsp; <span >{tableData && tableData?.Data[0]?.EventName}</span>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ marginBottom: 1 }}>
                                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                                    <strong>Mobile No : </strong>&nbsp;&nbsp; <span>{tableData && tableData?.Data[0]?.MobileNo}</span>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ marginBottom: 1 }}>
                                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                                    <strong>Email ID : </strong>&nbsp;&nbsp; <span>{tableData && tableData?.Data[0]?.EmailID}</span>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ marginBottom: 1 }}>
                                                <Typography variant="body2" color="text.primary" sx={{ display: 'flex', color: 'var(--text)', alignItems: 'center', fontSize: '0.875rem' }}>
                                                    <FaBarcode style={{ marginRight: '8px', color: '#9c27b0' }} />
                                                    <strong>Download Admit Card : </strong>&nbsp;&nbsp; <span>
                                                        {tableData?.Data[0]?.PrintUrl &&
                                                            <FaFilePdf title='open PDF'
                                                                style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}
                                                                onClick={() => { downloadFile(tableData && tableData?.Data[0]?.PrintUrl, `${tableData?.Data[0]?.RollNo}.pdf`) }}
                                                            />
                                                        }</span>
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </StyledCard>
                        </div>
                        <div className='col-sm-4'>
                            <StyledCard key={'2'}>
                                <CardHeader
                                    title={
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Typography variant="body2" sx={{ fontSize: '0.875rem' }}>
                                                <div className='d-flex align-items-center justify-content-center gap-2'>
                                                    <strong>Update Mobile No/Email ID</strong>
                                                </div>
                                            </Typography>
                                        </Box>
                                    }
                                    sx={{ backgroundColor: 'var(--last_bg_all)', color: 'var(--text)', padding: '10px', borderBottom: `1px solid red` }}
                                />
                                <Divider />
                                <CardContent sx={{ padding: '10px', paddingTop: '0px' }}>
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <InputBox
                                                id="txtAlternateMobileNo"
                                                labelclass={'mb-0 fs-6'}
                                                placeholder="Mobile No"
                                                divclassname='col-sm-12'
                                                label='Mobile No'
                                                autoComplete="off"
                                                maxLength='10'
                                                required={true}
                                                value={formData.alternateMobileNo}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, alternateMobileNo: convertToNumber(e.target.value) })
                                                }}
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputrefs.current['txtAlternateEmailID'].focus()
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <InputBox
                                                id="txtAlternateEmailID"
                                                labelclass={'mb-0 fs-6'}
                                                placeholder="Email ID"
                                                divclassname='col-sm-12 '
                                                label='Email No'
                                                autoComplete="off"
                                                maxLength='100'
                                                required={true}
                                                value={formData.alternateEmailID}
                                                onChange={(e) => {
                                                    setFormData({ ...formData, alternateEmailID: (e.target.value) })
                                                }}
                                                inputrefs={inputrefs}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        inputrefs.current['btnSub'].focus()
                                                    }
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <div className='main-card py-0 pt-1 my-0 px-1' style={{ boxShadow: 'none' }}>
                                                <button type="button"
                                                    onClick={handleSubmit}
                                                    className="btn btn-rounded btn-sm text-light btn-success" >
                                                    <span className=" text-white me-2">
                                                    </span><i className="fa">&#xf0c7;</i> Update</button>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </StyledCard>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
export default UpdateCandidateData;

export const StyledCard = styled(Card)(({ theme, borderColor }) => ({
    maxWidth: '100%',
    margin: '14px',
    float: 'left',
    boxShadow: theme.shadows[3],
    border: `2px solid ${borderColor}`,
    borderRadius: '8px',
}));